import Image from "next/image"
import upscbanner1 from "../../assets/images/home/Banner/UPSC-result-web-banner-2026.jpg";
// import phone from "../../assets/images/upsc/phone.png";
import downloadicon from "../../assets/images/download.png";
import styles from "../upsc-admission-anna-nagar/upsc-ias-ips-admission.module.css";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import dynamic from "next/dynamic";
const Interest = dynamic(()=>import("../../components/might-be-interest"));
const Acheiver = dynamic(()=>import("../../components/our-acheiver/achievers"));
const BranchAddress = dynamic(()=>import("../../components/branch-address"));
const ObtionalButton = dynamic(()=>import("../../components/optionalbutton"));
import Program_Features from "../upsc-admission-anna-nagar/upsc-ias-ips-admission-program-features";
import Classroom_form from "../upsc-admission-anna-nagar/upsc-ias-ips-admission-form";
import Upsc_popup from "../../assets/images/upsc/Covai-Popupnew.jpeg";
import Close from "../../assets/images/home/Icon ionic-ios-close-circle.png";
import Modal from 'react-bootstrap/Modal';
import sadhana from "../../assets/images/upsc/sadhanaL-2.png";
import useDownloader from "react-use-downloader";
import Link from "next/link";
import Head from "next/head";
import Emioption from "../../components/Service/emioption";
import Optionalplus from "../../components/Service/optionalplus";
import { useEffect, useState } from 'react';
import { useRouter } from "next/router";
const UPSCClassroomOnline = () => {
  
  const [selectedBranch, setSelectedBranch] = useState("Tamil Nadu");
  const {download} = useDownloader();
  const fileUrl = "/pdf/UPSC-2026/Brochure-Chennai-Admission-2026.pdf";
  const filename = "SIA-Brochure-2025-Annanaga.pdf"

  const feestructure =[
    {date:"27.04.2026", cont:"Regular", cont1:"08:00 am to 10:30 am"},
    {date:"31.05.2026", cont:"Weekend", cont1:"02:00 pm to 07:30 pm"},
    {date:"10.06.2026", cont:"Regular", cont1:"08:00 am to 10:30 am"},
 
  ]

  const feestructure2 =[
    {date:"05.07.2026",cont:"Weekend",cont1:"09:00 am to 01:00 pm"},
    
  ]

  const feestructure3 =[

    {date:"04.07.2026",cont:"Weekend",cont1:"PSIR",cont2:"09:00 am to 01:00 pm"},
   
    {date:"05.07.2026",cont:"Weekend",cont1:"Public Administration",cont2:"09:00 am to 01:00 pm"},
    {date:"05.07.2026",cont:"Weekend",cont1:"Geography",cont2:"09:00 am to 01:00 pm"},
    {date:"05.07.2026",cont:"Weekend",cont1:"Tamil literature",cont2:"09:00 am to 01:00 pm"},
    {date:"11.07.2026",cont:"Weekend",cont1:"Mathematics",cont2:"08:30 am to 01:30 pm"},
    
    {date:"12.07.2026",cont:"Weekend",cont1:"History",cont2:"09:00 am to 01:00 pm"},
    {date:"25.07.2026",cont:"Weekend",cont1:"Psychology",cont2:"09:00 am to 01:00 pm"},
    {date:"01.08.2026",cont:"Weekend",cont1:"Economics",cont2:"09:00 am to 01:00 pm"},
    
    {date:"06.07.2026",cont:"Regular",cont1:"Anthropology",cont2:"02:30 pm to 04:30 pm"},
    {date:"20.07.2026",cont:"Regular",cont1:"Agriculture",cont2:"06:30 pm to 08:30 pm"},
    {date:"24.07.2026",cont:"Regular",cont1:"Sociology",cont2:"05:00 pm to 07:30 pm"},
    {date:"14.08.2026",cont:"Regular",cont1:"English",cont2:"02:30 pm to 05:00 pm"},
    {date:"14.09.2026",cont:"Regular",cont1:"Law",cont2:"02:30 pm to 05:00 pm"}
  ]


  const jsonLd ={
   "@context": "https://schema.org",
  "@type": "EducationalOrganization",
  "name": "Shankar IAS Academy Coimbatore (UPSC)",
  "description": "Direct branch of Shankar IAS Academy offering UPSC coaching in Coimbatore",
  "url": "https://www.shankariasacademy.com/coimbatore/",
  "logo": "https://www.shankariasacademy.com/logo.png",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Gayathri Building, 2nd Floor, Old #220B, New #149B, Dr. Rajendra Prasad Road (100 ft Road)",
    "addressLocality": "Coimbatore",
    "addressRegion": "Tamil Nadu",
    "postalCode": "641012",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "11.0168",
    "longitude": "76.9558"
  },
  "telephone": "+91-90031-90030",
  "parentOrganization": {
    "@type": "Organization",
    "name": "Shankar IAS Academy",
    "url": "https://www.shankariasacademy.com"
  },
  "ownershipFundingInfo": "Owned and operated directly by Shankar IAS Academy"
  }

  const router = useRouter();

  useEffect(() => {
    const handleRouteChange = (url) => {
      console.log(`Navigated to ${url}`);
      router.reload(); // Refresh the page on route change
    };

    router.events.on("routeChangeComplete", handleRouteChange);
    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router]);
 const [show, setShow] = useState(false);

  useEffect(() => {
    // Runs after every page load / refresh
    setShow(true);
  }, []);

    const getBranchName = () => {
    switch (router.pathname) {
      case "/adyar":
        return "Adyar";
      case "/trichy":
        return "Trichy";
      case "/salem":
        return "Salem";
      case "/madurai":
        return "Madurai";
      case "/coimbatore":
        return "Coimbatore";
      case "/upsc-admission-anna-nagar":
        return "Tamil Nadu";
      default:
        return "Tamil Nadu";
    }
};

  const branches = [
    
    { name: "Bengaluru", path: "/bengaluru" },
    { name: "Delhi", path: "/delhi" },
    { name: "Hyderabad", path: "/hyderabad" },
    { name: "Bhubaneswar", path: "/bhubaneswar" },
    { name: "Thiruvananthapuram", path: "/thiruvananthapuram" },
    { name: "Online Class", path: "/upsc-online-class" },
    { name: "NRI", path: "/upsc-admission-nri" },

  ];


    return (
      <>
              <Head>
                <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd,null, "\t") .replaceAll("],\n\t\"", "],\n\n\t\"") }} />
                <meta charset="UTF-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="robots" content="noodp,noydir" />
                <meta name="robots" content="index,follow" />
                <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
                <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
                <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
                <title>IAS Academy in Coimbatore | Shankar IAS Academy</title>
                <meta name="title" content="IAS Academy in Coimbatore | Shankar IAS Academy" />
                <meta name="description" content="Unleash your potential at the top IAS Academy in Coimbatore. Experienced faculty, comprehensive curriculum, and unwavering support for aspirants." />
                <link rel="canonical" href="https://www.shankariasacademy.com/coimbatore/" />
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="website" />
                <meta property="og:title" content="IAS Academy in Coimbatore | Shankar IAS Academy" />
                <meta property="og:description" content="Unleash your potential at the top IAS Academy in Coimbatore. Experienced faculty, comprehensive curriculum, and unwavering support for aspirants." />
                <meta property="og:url" content="https://www.shankariasacademy.com/coimbatore/" />
                <meta property="og:site_name" content="Shankar IAS Academy" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@shankarias" />
                <script>{`var s=document.createElement("script"); s.type="text/javascript"; s.async=true; s.src="https://widgets.in6.nopaperforms.com/emwgts.js"; document.body.appendChild(s); `}</script>
              </Head>

              {/* <Modal
                size="md"
                centered
                show={show}
                onHide={() => setShow(false)}
                aria-label="UPSC Modal"
                className="blur"
              >
              <Modal.Body className="p-0">
                <div className="position-absolute  p-0 p-md-1 closebtn">
                  <Image loading="eager" placeholder="blur" onClick={() => setShow(false)} alt="Close icon" title="Close modal" src={Close} className="img-fluid" style={{ cursor: "pointer", width: "20px" }} />                 
                </div>
                <Link
                  href="https://forms.cloud.microsoft/pages/responsepage.aspx?id=6s_1g2Np5EW0Cl8sxgG4JZPgmAJwL0ZDvGfS1Cok3L9URVkxMkNVUlRMMEhDVTI1VVIyRVBRNjQySi4u&route=shorturl"
                  // target="blank"
                  className={`${styles.acheiverrank, styles.courseshover2}`}
                  id="" 
                  onClick={() => setShow(false)}
                >
                  <Image src={Upsc_popup} alt="Modal Banner" className="img-fluid w-100"  useMap="#image-map"/>                    
                </Link> 
              </Modal.Body>
              </Modal>  */}

              <Navbar title="upsc" />

              <div className="container">
                        <div className="row justify-content-center">
                          <div className="col-12 pt-3 pt-md-4">

                            {/* Desktop View */}
                            <div className={`${styles.tabscrollclass} ${styles.desktopView}`}>

                              <div className={styles.dropdown}>
                                <span className={styles.tamilNaduBtn}>
                                  {getBranchName()}
                                </span>

                                <ul className={styles.dropdownmenu}>
                                  <li><Link href="/upsc-admission-anna-nagar" className={styles.dropdownitem}>Anna Nagar</Link></li>
                                  <li><Link href="/adyar" className={styles.dropdownitem}>Adyar</Link></li>
                                  <li><Link href="/coimbatore" className={styles.dropdownitem}>Coimbatore</Link></li>
                                  <li><Link href="/trichy" className={styles.dropdownitem}>Trichy</Link></li>
                                  <li><Link href="/salem" className={styles.dropdownitem}>Salem</Link></li>
                                  <li><Link href="/madurai" className={styles.dropdownitem}>Madurai</Link></li>
                                </ul>
                              </div>

                              {branches.map((branch) => (
                                <Link key={branch.path} href={branch.path}>
                                  <button
                                    className={
                                      router.pathname === branch.path
                                        ? styles.activeBranch
                                        : styles.normalBranch
                                    }
                                  >
                                    {branch.name}
                                  </button>
                                </Link>
                              ))}
                            </div>

                            {/* Mobile & Tablet View */}
                            <div className={styles.mobileView}>

                              <div className={styles.dropdown}>
                                <span className={styles.tamilNaduBtn}>
                                  {getBranchName()}
                                </span>

                                <ul className={styles.dropdownmenu}>
                                  <li><Link href="/upsc-admission-anna-nagar" className={styles.dropdownitem}>Anna Nagar</Link></li>
                                  <li><Link href="/adyar" className={styles.dropdownitem}>Adyar</Link></li>
                                  <li><Link href="/coimbatore" className={styles.dropdownitem}>Coimbatore</Link></li>
                                  <li><Link href="/trichy" className={styles.dropdownitem}>Trichy</Link></li>
                                  <li><Link href="/salem" className={styles.dropdownitem}>Salem</Link></li>
                                  <li><Link href="/madurai" className={styles.dropdownitem}>Madurai</Link></li>
                                </ul>
                              </div>

                              {branches.map((branch) => (
                                <Link key={branch.path} href={branch.path}>
                                  <button
                                    className={
                                      router.pathname === branch.path
                                        ? styles.activeBranch
                                        : styles.normalBranch
                                    }
                                  >
                                    {branch.name}
                                  </button>
                                </Link>
                              ))}
                            </div>

                          </div>
                        </div>
              </div>

                {/* <div className="container">
                    <div className="row">
                        <div className="col pt-3 pt-md-4">
                            <div className={`${styles.tabscrollclass} nav nav-pills align-items-baseline`}>
                                <Link href="/upsc-admission-anna-nagar"><button id={styles.tablinks} className="nav-link tab1 py-2 px-0 me-4" type="button">Anna Nagar</button></Link>
                                <Link href="/adyar"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Adyar</button></Link>
                                <Link href="/bengaluru"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Bengaluru</button></Link>
                                <Link href="/coimbatore"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4 active" type="button">Coimbatore</button></Link>
                                <Link href="/delhi"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Delhi</button></Link>
                                <Link href="/hyderabad"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Hyderabad</button></Link>
                                <Link href="/thiruvananthapuram"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Thiruvananthapuram</button></Link>
                                <Link href="/trichy"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Trichy</button></Link>
                                <Link href="/salem"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Salem</button></Link>
                                <Link href="/madurai"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Madurai</button></Link>
                                <Link href="/upsc-online-class"><button id={styles.tablinks} className="nav-link tab10 py-2 px-0 me-4" type="button">Online Class</button></Link>
                                <Link href="/upsc-admission-nri"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">NRI</button></Link>
                            </div>
                        </div>
                    </div>
                </div> */}
                
                <div className="container">
                    <div className="row">
                        <div className="col pt-4 pt-md-4">
                            <h1 className={`${styles.pagemaintitle}`}>UPSC - Classroom & Online - Coimbatore</h1>
                            <Image
                                src={upscbanner1}
                                className="img-fluid w-100 pt-2"
                                alt="Classroom and online coaching"
                                title="Classroom and online coaching"
                              />
                        </div>
                    </div>
                </div>

{/* <Classroom_form branchname="Coimbatore"/> */}

<div className="container pb-5">
<div className={`${styles.coursesimg} mb-2`}>
  <div class="col-12 col-md-6 offset-md-3 mt-4">
  <p className={`${styles.contactheader} text-center`}>Enquiry</p>
  <p className={`${styles.acheiverrank} text-center mb-0 `}>kindly fill out the form below. We will get in touch with you shortly.</p>
  <div class={`${styles.addmissionform} npf_wgts mt-2`} data-height="550px" data-w="3f4274baec4df825dd72c5ff92d085ff"> </div> 
  </div>
  </div>
</div>

 {/* <div className="container-fluid">
    <div className={`${styles.bestbg1}`}>
      <div className="row g-4 mt-2">
        <div className="col-12 col-md-6 col-lg-12" id="pregspcm" >
          <div className="card shadow-sm p-4">
             <h2> Pre Booking Open</h2> 
            <p>
              GSPCM will start on 16th February 2026. For pre-booking, contact the number - <span style={{color:'#db1b0d' }}>98898 98868</span> 
            </p>
          </div>
        </div>   
      </div>
    </div>
  </div> */}

<div className={`${styles.sadhana} `}>
<div className="container">
  <div className="row">

  {/* <div className="col-12 col-md-4 text-white mt-2 p-2">
    UPSC GS-Mains Test Series 2025 (Moksha)<br />
    <a href="/upsc-mains-test-series/" className={`${styles.normalbutton} pt-2 pe-3 pb-2 ps-3 mt-2 d-inline-block`}> Click here <span></span></a>
    </div> */}

   {/* <div className="col-12 offset-md-4 col-md-4 p-2">
    <Link href="/two-year-upsc-program">
      <Image alt="sadhana" className="img-fluid" src={sadhana} />
    </Link>
  </div> */}
  
{/*  
 <div className="col-12 col-md-4 text-white mt-2 p-2 order-first order-md-last">UPSC GSPCM 2025 (Brochure)<br />
     <button className={`${styles.normalbutton2} ${styles.brochurebtn} pt-2 pe-3 pb-2 ps-3 mt-2 d-inline-block`} onClick={() => download(fileUrl, filename)}>
        <p className=""> <Image src={downloadicon} alt="download icon" /> Download Brochure</p>
      </button>
 </div> */}
</div>
</div>
</div>

<Program_Features />



    <section id="toppers">

<div className="container">
  <div className="row">
    <div className="col-xl-12 col-lg-6 mb-3 mb-md-4 col-12 ">
      <Optionalplus /> 
    </div>
  </div>
</div>
</section>
    
  {/* CSAT Program 
  <div className="container pt-3">
        <div className="col-12">
          <div className="csattable">
            <div className="row csathead">
              <div className="col-12 col-lg-2">
                  <p className={`${styles.tableheading1} mb-0`}>CSAT</p>
              </div>
              <div className="col-12 col-lg-4">
                  <p className={`${styles.tablepara1} mb-0`}>27th January 2024<br/>(Weekend	09:00 am to 01:00 pm)</p>
              </div>
              <div className="col-12 col-lg-2">
                  <p className={`${styles.tablepara1} mb-0`}>₹ 22,000</p>
              </div>
              <div className="col-12 col-lg-4">
                  <p  className={`${styles.tablepara1} mb-0`}>Admission - <Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></p>
              </div>
            </div>
          </div>
        </div>
    </div> */}
    <div className="container " id="courseandfees">
      <div className="row pt-2">

       <div className={`${styles.brochure}`}>
      <h2 className={`${styles.sectiontitle} pt-3`}>Course and Fees</h2>
     <div className={`${styles.brochure} `}>
                <a href="https://www.shankariasacademy.com/pdf/UPSC-2026/Brochure-Covai-Admission-2026.pdf" target="_blank" rel="noopener noreferrer">
                    <button className={`${styles.normalbutton1} btn btn-danger`}>
                     <Image src={downloadicon} alt="download icon" /> UPSC GSPCM 2026 (Brochure)
                    </button>
                </a>
            </div>
      </div>
    
        <div className="col-xl-4 col-lg-6 mb-3 mb-md-4 col-12">
        <div className="row p-2">
          <div className={`${styles.facultyborder3} col-lg-8`} >
            <p className={`${styles.sectionsubtitle} mb-0 mx-3`}>General Studies</p>
            <p className={`${styles.sectionsubtitle} mx-3`}>(Preliminary Cum Mains)</p>
            <span className={`${styles.acheiverrank} mx-3`}> <span className={`${styles.sectionredtitle} pe-1`}><b>₹</b>1,38,000</span><span style={{verticalAlign: "top"}}>(inclusive of tax)</span></span>
          </div>

          <div className={`${styles.facultyborder3} col-lg-4 pt-4`} >
            <a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noreferrer" className={`${styles.viewbuttonalink}`}><button type="button" className={`${styles.gsbutton}`}>Pay Here</button></a>
          </div>
        </div>
         
      <div className="pt-3">       
        <div className="row mx-auto">
          <div className="col ps-0">
               <span><small>*Subject to change based on the election date</small></span>
          <table className="table ">
            <tbody>
            
            {feestructure.map((item,index)=>(
              <tr key={index}>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.date}</td>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.cont}</td>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.cont1}</td>
              </tr>
              ))}
              <tr>
             

              </tr>
            </tbody>
          </table>
          </div>
        </div>
      </div>

      </div>
    

      <div className="col-xl-4 col-lg-6 mb-3 mb-md-4 col-12">
        
         <div className="row p-2">
          <div className={`${styles.facultyborder3} col-lg-8`} >
            <p className={`${styles.sectionsubtitle} mb-0 mx-3`}>CSAT</p>
            <span className={`${styles.acheiverrank} mx-3`}> <span className={`${styles.sectionredtitle} pe-1`}><b>₹</b>14,000</span><span style={{verticalAlign: "top"}}>(inclusive of tax)</span></span>
          </div>

          <div className={`${styles.facultyborder3} col-lg-4 pt-4`} >
            <a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noreferrer" className={`${styles.viewbuttonalink}`}><button type="button" className={`${styles.gsbutton}`}>Pay Here</button></a>
          </div>
        </div>
          

      <div className="pt-3">       
        <div className="row mx-auto">
          <div className="col ps-0">
          <table className="table ">
            <tbody>
            {feestructure2.map((item,index)=>(
              <tr key={index}>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.date}</td>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.cont}</td>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.cont1}</td>
              </tr>
              ))}
            <tr>
            
            </tr>
            </tbody>
          </table>
          </div>
        </div>
      </div>

      </div>


      <div className="col-xl-4 col-lg-6 mb-3 mb-md-4 col-12">
           <div className="row p-2">
          <div className={`${styles.facultyborder3} col-lg-8`} >
            <p className={`${styles.sectionsubtitle} mb-0 mx-3`}>Optional</p>
            <span className={`${styles.acheiverrank} mx-3`}> <span className={`${styles.sectionredtitle} pe-1`}><b>₹</b>34,000</span></span>
          </div>

          <div className={`${styles.facultyborder3} col-lg-4 pt-4`} >
            <a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noreferrer" className={`${styles.viewbuttonalink}`}><button type="button" className={`${styles.gsbutton}`}>Pay Here</button></a>
          </div>
        </div>


        <div className="pt-3" id="paymentsection">       
         <div className="row mx-auto">
          <div className="col ps-0 ps-xl-0 p-xl-0">
            <div className="table-responsive text-nowrap">
          <table className="table ">
            <tbody>
            {feestructure3.map((item,index)=>(
              <tr key={index}>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.date}</td>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.cont}</td>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.cont1}</td>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.cont2}</td>
              </tr>
              ))}
              <tr>
               <td colSpan="4" className={`${styles.classacheiverrank} mb-0`}><b>Forestry and Geology - After Prelims Result</b></td>
              </tr>
              <tr>
             
              </tr>
            </tbody>
          </table>
          </div>
          </div>   
        </div>
      </div>
     
      </div>
      
      <div className="col-xl-3 offset-xl-8 col-lg-4 col-md-6 col-8  text-end pb-2 ">
        <ObtionalButton />
      </div>

      <div className={`${styles.facultyborder3} row p-4 h-100 mb-md-3`}>
              <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                  <p className={`${styles.sectionsubtitle} mb-0`}>GSPCM+CSAT+Optional</p>
                  <p className={`${styles.sectionsubtitle} pb-0`}>Total Amount</p>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                    <span className={`${styles.acheiverrank}`}> <span className={`${styles.sectionredtitle} `}><b>₹</b>1,86,000*</span><span>(inclusive of tax)</span></span>

                </div>
            
                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2  text-right">
                   <Emioption />
                   
               </div>

               <div className="col-xl-3 col-lg-4 col-md-6 col-12  text-right pt-xl-0 pt-3">
                 <a href="https://admissionsv1.shankariasacademy.com/?center=COVAI&coursetype=UPSC" target="_blank" rel="noreferrer" className={`${styles.viewbuttonalink}`}><button type="button" className={`${styles.normalbutton}`}>Pay Here</button></a>
               </div>


      </div>
    </div>
    </div>

    {/* Our Acheivers */}
<div className="container">
        <div className="row">
          <div className="col pt-4 pt-md-5 text-center">
            <h2 className={`${styles.sectiontitle} mb-0`}>Our Achievers</h2>
            <p className={`${styles.sectionsubtitle}`}>
              Rank Holders from our academy
            </p>
          </div>
        </div>
      </div>

    <Acheiver />
                     
             {/* Location Section */}
            
            {/* <div className="container">
              <div className="row pt-3">
                  <div className="col">
                    <h2 className={`${styles.sectiontitle} mb-2`}>Venue</h2>
                    <p className={`${styles.sectionsubtitle} mb-1`}>Shankar IAS Academy</p>
                    <p className={`${styles.acheiverrank} mb-0`}>No : 790 , Cross Cut road,</p>
                    <p className={`${styles.acheiverrank} mb-0`}>Next to Josco Jewellers Building,</p>
                    <p className={`${styles.acheiverrank} mb-0`}>Gandhipuram,</p>
                    <p className={`${styles.acheiverrank}`}>Coimbatore 641012.</p>       
                  </div>
                  <p className={`${styles.acheivername}`}><Image src={phone} alt="Shankar IAS Academy coimbatore contact number" title="Contact number" className={`${styles.phoneiconcss} img-fluid pe-2`} /> <a href="tel:99945 51898" className={`${styles.numberbold}`}>99945 51898</a> . <a href="tel:0422-4380837" className={`${styles.numberbold}`}>0422-4380837</a></p>
                  <a href="https://goo.gl/maps/NPMuVydGTEAEZnJP8" target="_blank" rel="noreferrer" className={`${styles.redunderlinealink}`} style={{whiteSpace: "nowrap"}}>Get Direction</a>
              </div>
            </div>     */}
            <BranchAddress />
      <Interest />
      <Footer />                        
      </>
    )
  }
  
  export default UPSCClassroomOnline;
